import { Divider, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { stepLabelClasses, StepLabel } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

import { placeholderColor } from "../../DashMetrics/DashStyleGuides";

export const StepTitle = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
}));

interface StepLocationProps {
  color: string;
  wrap?: boolean;
}

export const StepLocation = styled("span")(({ color, wrap }: StepLocationProps) => ({
  color: `${color} !important`,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  whiteSpace: wrap ? "normal" : "nowrap",
  overFlow: wrap ? "hidden" : "auto",
  textOverflow: wrap ? "ellipsis" : "",
}));

export const EmptySectionWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  padding: "16px 18px",
}));

export const WrapperMessage = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",

  height: "100%",
  width: "100%",
  gap: 16,
}));

export const MessageTitle = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: 24,
  fontWeight: 500,
  lineHeight: "32px",
  textAlign: "center",
}));

export const MessageText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.25,
  textAlign: "center",
}));

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    "& .MuiStepper-root": {
      "& .MuiStep-root": {
        padding: 0,
        width: "100%",
        "& .MuiStepLabel-root": {
          height: "100%",
          "& .MuiStepLabel-labelContainer": {
            "& .MuiStepLabel-label": {
              height: "100%",
            },
          },
        },
        "& .MuiStepContent-root": {
          height: "100%",
          marginLeft: "20px",
          borderWidth: "2px",
        },
      },
    },

    "& .typ-date": {
      fontSize: 14,
      fontWeight: 400,
      color: placeholderColor,
      lineHeight: 1.6,
      fontFamily: "Manrope",
      letterSpacing: "0.25px",
    },

    "& .step-label-header .arrow-container": {
      visibility: "hidden",
    },

    "& .step-label-header:hover .arrow-container": {
      visibility: "visible",
    },
  },
  titleMargin: {
    paddingBottom: 16,
  },
}));

export const ColorlibStepLabelRoot = styled(StepLabel)(() => ({
  position: "relative",
  [`& .${stepLabelClasses.label}`]: {
    alignItems: "flex-start",
  },
}));

interface StepLabelHeaderProps {
  hasEvents?: boolean;
}

export const StepLabelHeader = styled("div")(({ hasEvents }: StepLabelHeaderProps) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  justifyItems: "space-between",
  alignItems: "flex-start",

  maxWidth: "500px",
  cursor: hasEvents ? "pointer" : "auto",
  borderRadius: "5px",
  padding: "5px",
  "&:hover": {
    backgroundColor: hasEvents ? "rgba(243,244,246,255)" : "none",
  },
}));

export const StepContentContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  justifyItems: "space-between",
  alignItems: "flex-start",
  marginLeft: "20px",
  paddingBottom: "15px",
}));

export const CustomStepper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  justifyItems: "space-between",
  alignItems: "flex-start",
  overflow: "hidden",
}));

interface StepItemLineProps {
  currentColor: string;
}
export const StepItemLine = styled(Divider)(({ currentColor }: StepItemLineProps) => ({
  transform: "translateX(-30px)",
  background: `${currentColor} !important`,
  width: "2px !important",
}));

interface StepIconContainerProps {
  color: string;
}

export const StepIconContainer = styled("span")(({ color }: StepIconContainerProps) => ({
  display: "flex",
  position: "relative",
  zIndex: 2,
  backgroundColor: color,
  height: "44px",
  width: "44px",
  borderRadius: "50%",

  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const StepItemContainer = styled("div")(() => ({
  display: "flex",
  position: "relative",

  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
  gap: "8px",
}));

export const StepItemBody = styled("div")(() => ({
  width: "100%",
  paddingBottom: "20px",
}));

export const ArrowContainer = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  right: "5px",
  transform: "translateY(-8px)",
}));

export default useStyles;
